import React, { useState } from 'react';
import { Box } from '@mui/material';
import CreateICPModal from '../../container/createICP/CreateICPView';
import ICPCard from './ICPCard';
import ICPMoreDetailsModal from './ICPMoreDetailsModal';
import { fieldList } from './utils';
import { convertObjectToQuerystring } from '../../../../utils/helper';
import toast from '../../../../utils/toast';

const ICPGrid = ({
  setShowICPForm,
  showICPForm,
  saveICP,
  icpsData,
  getICPById,
  updateICP,
  deleteICP,
  ...props
}) => {
  const [isDetailModal, setIsDetailModal] = useState({ isOpen: false, moreDetails: {} });

  const fetchJobList = async (search = '') => {
    const params = { _from: 0, _size: 50, search: search };

    const query = convertObjectToQuerystring(params);
    try {
      const response = await props.getJobsList(query, 'jobTitle');
      return response?.data?.map((item) => ({ label: item, value: item })) || [];
    } catch (error) {
      toast.error(error?.error?.message || 'Fetching Jobs Failed.');
      return [];
    }
  };

  const fetchTechUsed = async (search = '') => {
    const params = { _from: 0, _size: 50, search: search };
    const query = convertObjectToQuerystring(params);
    try {
      const response = await props.getJobsList(query, 'techUsed');
      return response?.data?.map((item) => ({ label: item, value: item })) || [];
    } catch (error) {
      toast.error(error?.error?.message || 'Fetching Jobs Failed.');
      return [];
    }
  };

  const transformedData = icpsData?.data?.map((icp) => {
    const data = {
      profileType: icp.profileType === 'organisation' ? 'Customer' : 'Candidate',
      name: icp.name,
      status: icp.status,
      id: icp?.id,
    };

    fieldList.forEach((field) => {
      const fieldKey = field.key;

      let fieldValue;
      if (fieldKey === 'jobTitle') {
        fieldValue = icp[fieldKey];
      } else {
        fieldValue = icp[fieldKey]?.value || icp[fieldKey];
      }
      if (fieldValue) {
        data[fieldKey] = fieldValue;
      } else {
        data[fieldKey] = null;
      }
    });

    return data;
  });

  return (
    <>
      <Box sx={{ paddingTop: '24px' }}>
        <Box display={'flex'} gap={'12px'} flexWrap={'wrap'}>
          {transformedData?.map((item, index) => (
            <Box display={'flex'} gap={'12px'} flexWrap={'wrap'} key={index}>
              <ICPCard
                data={item}
                setIsDetailModal={setIsDetailModal}
                setShowICPForm={setShowICPForm}
                updateICP={updateICP}
                deleteICP={deleteICP}
                icpsData={icpsData?.data}
                {...props}
              />
            </Box>
          ))}
        </Box>
      </Box>
      <CreateICPModal
        showICPForm={showICPForm}
        setShowICPForm={setShowICPForm}
        saveICP={saveICP}
        getICPById={getICPById}
        updateICP={updateICP}
        fetchJobList={fetchJobList}
        fetchTechUsed={fetchTechUsed}
        {...props}
      />
      <ICPMoreDetailsModal
        isDetailModal={isDetailModal}
        handleClose={() => setIsDetailModal({ isOpen: false, moreDetails: {} })}
      />
    </>
  );
};
export default ICPGrid;
